import { CacheKeyType } from "../domainObjects/transformType";

export class ResetRefineryNodesStatusRequest {
   refineryId: string;
   userId: string;
   // See RunrefineryRequest.tabId — same purpose: lets the Flask engine
   // check this call against the refinery's Edit-lock presence file.
   tabId: string;

   constructor(refineryId: string, userId: string = '', tabId: string = '') {
        this.refineryId = refineryId;
        this.userId = userId;
        this.tabId = tabId;
   }
}

export class ResetNodeStatusRequest {
   refineryId: string;
   nodeId: string;
   constructor(refineryId: string,nodeId: string) {
      this.refineryId = refineryId;
      this.nodeId = nodeId;
   }
}

export class ResetNodeStatusResponse {
   transformerCacheStatus: string[];
   /** guid -> last Run Node result (status/message/runTime/outputRows/outputCols) —
    *  populates the Node page's Last Run Status, Output Rows, Output Cols and Run Time
    *  columns. runTime is "N.nn secs" or blank when this transformer didn't run in the
    *  last invocation; outputRows/outputCols are blank (null) when it produced zero rows. */
   transformerLastRunStatus?: { [guid: string]: { status: string; message: string; runTime: string; outputRows: number; outputCols: number } };
   constructor(transformerCacheStatus: string[]) {
      this.transformerCacheStatus = transformerCacheStatus;
   }
}

export class TransformerCacheStatus {
   transformerCacheStatus: string;
   transformerId: string;
   constructor(transformerCacheStatus: string,transformerId: string) {
      this.transformerCacheStatus = transformerCacheStatus;
      this.transformerId = transformerId;
   }
}

export class CacheStatusRequest {
   userId: string;
   orgId: string;
   refineryId: string;
   nodeId: string;
   transformId: string;
   cacheKeyType:CacheKeyType;
   // Live (possibly unsaved) config + transform type -- required for the 4-state
   // indicator (Not Cached / Local Cache / Pipeline Cache / Both Cache), which
   // validates cache hits by exact hash match against what's currently in the editor
   // rather than trusting plain existence. Optional so any caller still on the
   // 2-state Node-cache check path doesn't need to supply them.
   transformConfig?: any;
   transformType?: number;
   constructor(userId: string,
        orgId: string,
        refineryId: string,
        nodeId: string,
        transformId: string,
        cacheKeyType:CacheKeyType,
        transformConfig?: any,
        transformType?: number) {
      this.userId = userId;
      this.orgId = orgId;
      this.refineryId = refineryId;
      this.nodeId = nodeId;
      this.transformId = transformId;
      this.cacheKeyType = cacheKeyType;
      this.transformConfig = transformConfig;
      this.transformType = transformType;
   }
}

export class CacheStatusResponse {
   status: string;
   transformId: string;
   cacheStatus: string;
   constructor(status: string,transformId: string,cacheStatus: string) {
      this.status = status;
      this.transformId = transformId;
      this.cacheStatus = cacheStatus;
   }
}
